import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "skeleton";
export var SKELETON_CONSTANTS = {
    elementName: elementName
};
